export default __webpack_public_path__ + "media/images/oak-rise-plot-2-hr-43a42357dd96c1b2475a12e6074d2507.png";